/** Web: build-time HRMS_API_URL / VITE_API_URL (see vite.config.mts), else the local Laravel server. */
declare const process: { env: Record<string, string | undefined> };

export const DEFAULT_API_URL = (process.env.HRMS_API_URL || 'http://localhost:8000/api').replace(/\/+$/, '');

export const normaliseBaseUrl = (u: string) => {
  let url = u.trim().replace(/\/+$/, '');
  if (url && !/^https?:\/\//i.test(url)) url = `http://${url}`;
  return url;
};

export const DEMO = { tenant: 'acme', email: 'admin@acme.test', password: 'password' };
